// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {Editor} from '../../../shared/editor/editor';
import {use_siteicon} from '../ui/use_siteicon';
import {Spinner} from '../lib/spinner';
import styles from './about_domain_banner.module.less';

interface i_domain_info {
    description: string;
    category: string;
    name: string;
}

const use_domain_info = (domain: string)=>{
    const [info, set_info] = useState<i_domain_info | null>(null);
    const [loading, set_loading] = useState(false);
    useEffect(()=>{
        if (!domain)
            return;
        set_loading(true);
        fetch('/www_cms/get_domain_info?domain='
            +encodeURIComponent(domain)).then(res=>{
                if (res.results[domain] && !res.results[domain].error)
                    set_info(res.results[domain]);
                set_loading(false);
        }).catch(()=>{
            set_info(null);
            set_loading(false);
        });
    }, [domain]);
    return {info, loading};
};

interface i_about_domain_banner_props {
    domain: string;
}

export const About_domain_banner = (props: i_about_domain_banner_props)=>{
    const {theme} = useContext(Settings_context);
    const {info, loading} = use_domain_info(props.domain);
    const {icon_link} = use_siteicon({link: props.domain});
    return <div className={styles.wrapper}>
      <div className={cn([theme.container, styles.container])}>
        <div className={styles.text_container}>
          <h3>
            About <span className={styles.coloured}>{props.domain}</span>
          </h3>
          <p className={cn([theme.p2, styles.info])}>
            {loading ? <Spinner small={true}/> :
              info?.description || 'No information available.'}
          </p>
        </div>
        <div className={styles.img_container}>
          <img src={icon_link} alt={`${props.domain} icon`} />
        </div>
      </div>
    </div>;
};

interface i_about_domain_banner_editor_props {
    value: i_about_domain_banner_props;
    on_change: (new_val: i_about_domain_banner_props)=>void;
}

export const About_domain_banner_editor = (
props: i_about_domain_banner_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change}
      editors={[]}/>;
};
